import {svgCode} from '../helper/spinnerSvg'

const Spinner = () => {
    
    return (
        <div className="spinner__container">{svgCode}</div>
    );
}

export default Spinner;